import React from "react";
import {
  FormattedMessage 
} from "react-intl";

import LoadingIndicator from "./indicator";

const staticIndicator = (
  <LoadingIndicator global={true}>
    <FormattedMessage
      id={"loadingIndicator.loadingMessage"}
      defaultMessage={"Loading..."}
    />
  </LoadingIndicator>
);

export default staticIndicator;
